import '../solar-panels/collection.less'
import './index.less'
import Accordion from '../solar-panels/accordion-menu.js'

import Collection from '../solar-panels/collection.js'

class HowItWork {
    constructor(el) {
        this.DOM = {
            el: el.el,
            swiperContainer: el.swiperContainer
        };
        this.init();
    }
    init() {
        const self = this
        this.swiper = new Swiper(this.DOM.swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            // autoplay: {
            //     delay: 7000,
            //     disableOnInteraction: false,
            // },
            autoplay: false,
            followFinger: false,
            pagination: {
                el: `${this.DOM.el} .slideshow-pagination`,
                clickable: true,
                bulletClass: 'slideshow-pagination-item',
                bulletActiveClass: 'active pagination-active',
                clickableClass: 'slideshow-pagination-clickable',
                modifierClass: 'slideshow-pagination-',
                renderBullet: function (index, className) {
                    var slideIndex = index,
                        number = (index <= 8) ? '0' + (slideIndex + 1) : (slideIndex + 1);

                    var paginationItem = '<span class="slideshow-pagination-item">';
                    paginationItem = (index <= 8) ? paginationItem +
                        '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
                        paginationItem;
                    paginationItem += '</span>';
                    return paginationItem;
                },
            },
            on: {
                resize: function () {
                    setTimeout(() => {
                        this.update()
                    }, 600);
                }
            },
            navigation: {
                nextEl: `${this.DOM.el} .slideshow-navigation-button.next`,
                prevEl: `${this.DOM.el} .slideshow-navigation-button.prev`,
            },
        });
    }
}


class PPSCollection extends Collection {
    constructor({swiperContainer1, swiperContainer2, swiperProductContainer, swiperProductsPagination, ...props}) {
        super({...props})
        this.swiperContainer1 = swiperContainer1
        this.swiperContainer2 = swiperContainer2
        this.swiperProductContainer = swiperProductContainer
        this.swiperProductsPagination = swiperProductsPagination

        this.isMobile = document.body.clientWidth < 1024

        const productsDOM = document.querySelector('[data-collection-products]')
        if (productsDOM) {
            this.productsArray = productsDOM.dataset.collectionProducts.split(',')
            this.initProductSwiper()
        }

        if (this.swiperContainer1) {
            this.reversedScroll()
        }
    }
    // 反向 无缝滚动
    reversedScroll() {
        const swiper1 = new Swiper(this.swiperContainer1, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 30000, // 滚动速度
            // freeMode: true,
            touchStartPreventDefault : true,
            centeredSlides: true,
            loop: true,
            loopAdditionalSlides: 4,
            autoplay: {
                delay: 1,
                disableOnInteraction: false, // 就算触摸了也继续滚动
                loopPreventsSlide: true,
            },
            breakpoints: {
                320: {  //当屏幕宽度大于等于320
                    speed: 10000, // 滚动速度
                },
                768: {  //当屏幕宽度大于等于768
                    speed: 30000, // 滚动速度
                },
            },
            on: {
                click: function(swiper, e){
                    if (e.target.parentElement?.href) {
                        window.location.href = e.target.parentElement.href
                    }
                    return false
                },
                touchMove: function(swiper, e){
                    console.log('move')
                },
            }
        })

        const swiper2 = new Swiper(this.swiperContainer2, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 30000, // 滚动速度
            // freeMode: true,
            touchStartPreventDefault : true,
            centeredSlides: true,
            loop: true,
            loopAdditionalSlides: 4,
            autoplay: {
                delay: 1,
                disableOnInteraction: false, // 就算触摸了也继续滚动
                loopPreventsSlide: true,
                reverseDirection: true, // 反向
            },
            breakpoints: {
                320: {  //当屏幕宽度大于等于320
                    speed: 10000, // 滚动速度
                },
                768: {  //当屏幕宽度大于等于768
                    speed: 30000, // 滚动速度
                },
            },
            on: {
                click: function(swiper, e){
                    if (e.target.parentElement?.href) {
                        window.location.href = e.target.parentElement.href
                    }
                    return false
                },
                touchMove: function(swiper, e){
                    console.log('move')
                },
            }
        })
    }
    // PPS 产品 swiper
    initProductSwiper() {
        const _this = this
        new Swiper(this.swiperProductContainer, {
            breakpoints: { 
                320: {  //当屏幕宽度大于等于320
                  slidesPerView: 1,
                  spaceBetween: 0
                },
                1024: {  //当屏幕宽度大于等于768
                  slidesPerView: 3,
                  spaceBetween: -30
                },
            },
            autoplay: this.isMobile,
            speed: 500,
            centeredSlides: true,
            loop: this.isMobile || this.productsArray.length > 2,
            on: {
                resize: function(){
                    setTimeout(() => {
                        _this.isMobile = document.body.clientWidth < 1024
                        this.update()
                    }, 400);
                },
            },
            pagination: {
                el: this.swiperProductsPagination,
                clickable: true,
                bulletClass: 'swiper-collection-product-pagination-item',
                bulletActiveClass: 'active swiper-collection-product-pagination-item-active',
                clickableClass: 'swiper-collection-product-pagination-clickable',
                modifierClass: 'swiper-collection-product-pagination-',
                renderBullet: function (index, className) {
                    const text = _this.productsArray[index]
                    return `
                        <div class="${className}">
                            <span>${text}</span>
                        </div>
                    `
                },
            },
            navigation: {
                nextEl: `.section-collection-product-swiper .slideshow-navigation-button.next`,
                prevEl: `.section-collection-product-swiper .slideshow-navigation-button.prev`,
            },
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new HowItWork({
        swiperContainer: '.image-text-swiper',
        el: '.image-text-swiper'
    });

    new PPSCollection({
        swiperContainer1: '.swiper-explore-1',
        swiperContainer2: '.swiper-explore-2',
        swiperProductContainer: '.swiper-collection-products',
        swiperProductsPagination: '.swiper-collection-products-pagination',
    });
    

    new Accordion($('.accordion-menu'), false);
    const faq_btn = $(".section-collection-faq .z-button-fill-middle")
    const { moreText, lessText, } = faq_btn.data()
    faq_btn.click(function() {
        const isActive = faq_btn.hasClass("active")
        const span = faq_btn.find('span').eq(0)
        if(isActive) {
            $(".section-collection-faq .accordion-menu").removeClass("active")
            faq_btn.removeClass("active")
            span.text(moreText)
        } else {
            $(".section-collection-faq .accordion-menu").addClass("active")
            faq_btn.addClass("active")
            span.text(lessText)
        }
    })
})
